import { LegalNotice, NoticeOfEntryNotice } from '../../constants';

export const modes = {
  SELECTING_PROPERTY: 'SELECTING_PROPERTY',
  SELECTING_PROPERTY_OPTIONS: 'SELECTING_PROPERTY_OPTIONS',
  SELECTING_UNIT: 'SELECTING_UNIT',
  SELECTING_FLOORS: 'SELECTING_FLOORS',
  SELECTING_ROWS: 'SELECTING_ROWS',
  SELECTING_UNIT_COTENANTS: 'SELECTING_UNIT_COTENANTS',
};

export const isLegalNotice = (values) => {
  return values.notice_type === LegalNotice;
};

export const isNoticeOfEntryNotice = (values) => {
  return values.notice_type === NoticeOfEntryNotice;
};

export const getTemplate = (noticeTemplates, templateId) => {
  return noticeTemplates.find((t) => t.id === templateId);
};

export const getTemplateValue = (template, key, fallback) => {
  if (template && key in template) {
    return template[key];
  }

  return fallback;
};

export const isTemplate = (values) => {
  const templateId = values.notice_template_id;
  return !!templateId && templateId !== 'none';
};

export const selectedProperties = (values, properties) => {
  return properties.filter((p) => values.properties.includes(p.value));
};

export const selectedUnits = (values, units) => {
  return units.filter((u) => values.units.includes(u.value));
};
